import { render, staticRenderFns } from "./ServiciosAdmin.vue?vue&type=template&id=1d4d1e9a&scoped=true"
import script from "./ServiciosAdmin.vue?vue&type=script&lang=js"
export * from "./ServiciosAdmin.vue?vue&type=script&lang=js"
import style0 from "./ServiciosAdmin.vue?vue&type=style&index=0&id=1d4d1e9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d4d1e9a",
  null
  
)

export default component.exports